module.exports = __webpack_public_path__ + "img/gray-search.909956ec.svg";